import styled from 'styled-components'
import theme from 'theme_'

export const SubsUpdateContainer = styled.div`
  display: flex;
  flex-direction: column;
`

export const SubsUpdateBody = styled.div`
  display: flex;
  padding-top: 16px;
  gap: 16px;
  flex-direction: column;
  @media ${theme.devices.tabletLandscape} {
    flex-direction: row;
  }
`

export const SubsUpdateLeftPanelContainer = styled.div`
  display: flex;
  width: 100%;
  @media ${theme.devices.tabletLandscape} {
    width: 65%;
  }
`

export const CloseBtn = styled.button`
  padding: 0;
  background-color: transparent;
  border: 0;
  outline: none;
  display: flex;
  align-self: flex-end;
  cursor: pointer;
`
